exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "table thead[data-v-1708ba28]{background-color:#053948;color:#fff}table thead th[data-v-1708ba28]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1708ba28","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/engagement/common/AdditionalDataTable.vue
// module id = 764
// module chunks = 1